var map = {
	"./dispatch_error.svg": "bfc1",
	"./dispatch_internet_error.svg": "f813",
	"./dispatch_server_error.svg": "616c",
	"./kondispatch_partially.svg": "e356",
	"./kondispatch_success.svg": "59ac",
	"./stldispatch_partially.svg": "b6af",
	"./stldispatch_success.svg": "bfb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ab0";